import { orgBasic } from 'api/UserController';

const getUsernamesByIds = async (userIds: string[]): Promise<string[]> => {
  const targetUserIds = Array.from(new Set(userIds));
  const users = await orgBasic({ targetUserIds, orgWide: false });
  return users.map(user => `${user.firstName} ${user.lastName}`);
};

export default getUsernamesByIds;
